// Theme preference (simple-mode S3, plan §5): the stored `user_preferences.theme`
// (GET/PATCH /me/preferences) is reflected on <html data-theme>. No palette work here:
// `system` resolves to the OS preference when the browser can tell, else the page default.
import type { Theme } from '../api/types'

const PAGE_DEFAULT = 'dark' // index.html ships <html data-theme="dark">

export function resolveTheme(theme: Theme | undefined): 'light' | 'dark' {
  if (theme === 'light' || theme === 'dark') return theme
  const mq = typeof window !== 'undefined' && typeof window.matchMedia === 'function'
    ? window.matchMedia('(prefers-color-scheme: light)')
    : null
  if (mq) return mq.matches ? 'light' : 'dark'
  return PAGE_DEFAULT
}

/** Set <html data-theme> for a stored preference (undefined = not loaded yet: no change). */
export function applyTheme(theme: Theme | undefined): void {
  if (!theme) return
  document.documentElement.dataset.theme = resolveTheme(theme)
}
